import { createStore } from '@vfde-sails/core';
import app from './container/App';
import './style.scss';

createStore({});
app();
